import * as React from "react"

const SvgPersonRemove = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20 10.925 18.6 12.3a.98.98 0 0 1-.688.287.93.93 0 0 1-.712-.287.95.95 0 0 1-.275-.7q0-.426.275-.7l1.375-1.4L17.2 8.125a.93.93 0 0 1-.275-.688q0-.412.275-.712.3-.3.713-.3.412 0 .712.3L20 8.1l1.375-1.4q.275-.3.688-.3t.712.3q.3.3.3.712 0 .413-.3.713L21.4 9.5l1.4 1.4q.3.3.287.7-.012.4-.312.7-.3.275-.7.287a.92.92 0 0 1-.7-.287zM9.5 12q-1.65 0-2.825-1.175T5.5 8c0-1.649.392-2.042 1.175-2.825Q7.85 4 9.5 4c1.65 0 2.042.392 2.825 1.175Q13.5 6.35 13.5 8c0 1.65-.392 2.041-1.175 2.825Q11.15 12 9.5 12m-8 6v-.8q0-.85.438-1.563A2.9 2.9 0 0 1 3.1 14.55a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 9.5 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087T17.5 17.2v.8q0 .825-.587 1.412A1.93 1.93 0 0 1 15.5 20h-12q-.824 0-1.413-.588A1.93 1.93 0 0 1 1.5 18m2 0h12v-.8a.97.97 0 0 0-.5-.85 13 13 0 0 0-2.725-1.013 11.6 11.6 0 0 0-5.55 0A13 13 0 0 0 4 16.35a.97.97 0 0 0-.5.85zm6-8q.825 0 1.412-.588Q11.5 8.825 11.5 8t-.588-1.413A1.93 1.93 0 0 0 9.5 6q-.825 0-1.412.587A1.93 1.93 0 0 0 7.5 8q0 .825.588 1.412Q8.675 10 9.5 10" />
  </svg>
)
export default SvgPersonRemove
